import { GridModelInterface } from "../../../../../shared/gridModel/gridModelEntity";
import { useLangLabels } from "../../../../../shared/lang/services/useLangLabels";

export const useModelGridModel = () => {
  const { lang } = useLangLabels();

  const gridModel: GridModelInterface = {
    id: { label: lang.globalentityValues.id },
    model: { label: lang.instruments.model },
  };

  return gridModel;
};
